<template>
  <div class="" id="trackPaginate" v-if="JobType != 'RVP'">
    <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isPendingShipmentforDeliveryLoader" />
    <table class="b-table table table-bordered pending-for-delivery-ShipmentList">
        <thead class="thead-default">
        <template v-if="this.JobType != ''">
          <tr>
            <th>Pending Days </th>
            <th>Pending At Dest</th>
            <th>Shipping ID</th>
            <th>RP ShippingId</th>
            <th>Total Attempts</th>
            <th>Last Status</th>
            <th>Shipping Date</th>
            <th>Net Payment</th>
            <th>Order Type</th>
            <th>IsSame DayDelv.</th>
            <th>EDD</th>
            <th>Address Type</th>
          </tr>
        </template>
        <template v-else>
          <tr>
            <th colspan="12" align="center"> Please select JobType to view all shipments.! </th>
          </tr>
        </template>
        </thead>
        <tbody>
          <template v-if="pendingShipmentForDeliveryobj.length>0">
            <tr v-for="row in pendingShipmentForDeliveryobj">
              <td>{{row.PendingDays}}</td>
              <td>{{row.PendingDays}}</td>
              <td>{{row.ShippingID}}</td>
              <td></td>
              <td>{{row.TotalAttemptCount}}</td>
              <td>{{row.ShipmentStatus}}</td>
              <td></td>
              <td>{{row.CollectibleAmount}}</td>
              <td>{{row.OrderType}}</td>
              <td>{{row.IsSameDayDelivery }}</td>
              <td>{{row.EDD}}</td>
              <td>{{row.AddressType}}</td>
            </tr>
          </template>
          <template v-else>
            <tr v-if="this.JobType != ''">
              <td colspan="12" align="center">No record found</td>
            </tr>
          </template>
        </tbody>
    </table>
    <paginate ref="paginate" v-if="totalPendingShipmentforDeliverycnt>20" :page-count="pageCount" :page-range="2" :margin-pages="2" :click-handler="getPaginationData" :prev-text="'<<'" :next-text="'>>'" :container-class="'pagination'">
    </paginate>
  </div>
  <div v-else="">
    <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isPendingShipmentforDeliveryLoader" />
    <table class="b-table table table-bordered ShipmentList" id="shipmentListRvp">
      <thead class="thead-default">
        <tr>
          <th class="text-center tableheader">
            <label>
              <input type="checkbox" v-model="checkAll" @click="selectAllShipments($event)">
            </label>
          </th>
          <th>Client Name</th>
          <!-- <th v-if="IsPaperlessFlyerbarcode">Flyer Barcode</th> -->
          <th>Shipping ID</th>
          <th>Pick Assign Date</th>
          <th>First Name</th>
          <th>Customer Address</th>
          <th>City</th>
          <th>Pincode</th>
          <th>Total Items</th>
          <th>Future Pickup Date</th>
          <th>Pending Days</th>
          <th>ReAttempt Count</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in pendingShipmentForDeliveryobj" :id="'rvpTr'+row.ShippingId" v-bind:style= "row.IsPickupPriority == true ? styleObjectsp : '' ">
          <td scope="row" class="text-center">
            <input type="checkbox" v-model="selectedReverseShipmentData" :value="row.ShippingId" :name="'selectedPickups'+index" @click="PassSelectedData()"  style="font-size:0.8em;">
          </td>
          <td>{{row.ClientName}}</td>
          <td>{{row.ShippingId}}</td>
          <td>{{row.CreatedDate | moment}}</td>
          <td>{{row.CustomerFirstName}}</td>
          <td>{{row.CustomerAddress}}</td>
          <td>{{row.CustomerCity}}</td>
          <td>{{row.CustomerPinCode}}</td>
          <td>{{row.TotalItems}}</td>
          <td>{{row.ReAttemptDate | moment}}</td>
          <td>{{row.PendingDays}}</td>
          <td>{{row.TotalAttemptCount}}</td>
          <input type="hidden" :value="row.ClientId" :id="'CI'+row.ShippingId">
        </tr>
        <tr v-if="pendingShipmentForDeliveryobj.length==0">
          <td colspan="12" align="center">No record found</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'

export default {
  name: 'pendingShipmentsforDelivery',
  components: {
    VueElementLoading,
    Paginate
  },
  data: function() {
    return{
      selectedReverseShipmentData: [],
      checkAll: false
    }
  },
  props: {
    pendingShipmentForDeliveryobj: {
      type: Array,
      required: true,
    },
    isPendingShipmentforDeliveryLoader: {
      type: Boolean,
      required: true,
    },
    pageCount: {
      type: Number
    },
    totalPendingShipmentforDeliverycnt: {
      type: Number
    },
    JobType: {
      type: String,
      required: true,
    }
  },
  mounted(){
    //console.log('test');
  },
  watch: {
    isPendingShipmentforDeliveryLoader(){
      this.selectedReverseShipmentData = [];
      this.PassSelectedData();
    }
  },
  methods: {
    selectAllShipments(ev) {
      this.selectedReverseShipmentData = [];
      if (ev.target.checked == true) {
        $.each(this.pendingShipmentForDeliveryobj, (key,value) => {
          this.selectedReverseShipmentData.push(value.ShippingId);
          this.$emit("getSelectedShipments", this.selectedReverseShipmentData);
        })
      }
    },
    PassSelectedData(){
      this.$emit("getSelectedShipments", this.selectedReverseShipmentData);
    },
    closeShipmentModel(){
      this.$emit("input", !this.value);
    },
    getPaginationData(pageNum){
      this.$emit("getPaginationDataChild", pageNum);
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/common/pendingShipmentsforDelivery.vue?1cf2d178